// Helper function to format date as "Weekday DD of Month"
export function formatDate(dateString) {
  const date = new Date(dateString);
  const weekdayNumeric = { weekday: "long", day: "numeric" };
  const monthLong = { month: "long" };
  const day = date.getDate();
  let suffix = "th";
  if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
  } else if (day === 2 || day === 22) {
    suffix = "nd";
  } else if (day === 3 || day === 23) {
    suffix = "rd";
  }

  return (
    date.toLocaleDateString("en-UK", weekdayNumeric).concat(suffix) +
    " " +
    date.toLocaleDateString("en-UK", monthLong)
  );
}
